// extracted by mini-css-extract-plugin
module.exports = {"hgroup":"Hgroup_hgroup__3NPUN","hgroup__left":"Hgroup_hgroup__left__k_qic","hgroup__right":"Hgroup_hgroup__right__VCCK2","hgroup__center":"Hgroup_hgroup__center__XT1S7"};